import md5 from 'md5';
import jsencrypt from 'jsencrypt';
import axios from 'axios';

let bods = {
  dataurl: '/data/dataapi',
  exp: {
    uuid: function () {
      let s = [];
      let hexDigits = '0123456789abcdef';
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr (Math.floor (Math.random () * 0x10), 1);
      }
      s[14] = '4';
      s[19] = hexDigits.substr ((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = '-';
      let uuid = s.join ('');
      return uuid;
    },
    uuid2: function () {
      let guid = bods.expmethod.uuid ();
      return bods.expmethod.replaceall (guid, '-', '0');
    },
    md5: function (s) {
      return md5 (s);
    },
    getQV: function (variable) {
      let query = window.location.search.substring (1);
      let vars = query.split ('&');
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split ('=');
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    replace: function (str, sptr, sptr1) {
      while (str.indexOf (sptr) >= 0) {
        str = str.replace (sptr, sptr1);
      }
      return str;
    },
    date: function () {
      var date = new Date ();
      var seperator1 = '-';
      var year = date.getFullYear ();
      var month = date.getMonth () + 1;
      var strDate = date.getDate ();
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
  },
  json: {
    loads: function (s) {
      return JSON.parse (s);
    },
    dumps: function (obj) {
      return JSON.stringify (obj);
    },
    merge: function (target, source) {
      return Object.assign (target, source);
    },
  },
  encrypt: {
    rsa: function (s) {
      let publickey = bods.storage.getitem ('publickey');
      let encrypt = new jsencrypt ();
      encrypt.setPublicKey (publickey);
      return encrypt.encrypt (s);
    },
    local:{
      en:function(s){
          let encryptor = new jsencrypt()
          let pubKey = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDE2xbyboHyOatd3sWwOxcX3iN6q7Y8EwiIeNXtYqOY0ehUGL7vK6UKEjSk+A9t1hLeqWO4hDnPdKzBhGB6PoCaULOXPQqZC5N1ieL++JtvocZeoEj7sKQYX3UCgfdLZOxU2iXJnD0Pt8wAYduddGbL/7iwgXSU+dL3OJ2t6Y3j8QIDAQAB-----END PUBLIC KEY-----'
          encryptor.setPublicKey(pubKey)
          return encryptor.encrypt(s)
      },
      de:function(s){
          let decrypt = new jsencrypt()
          let priKey  = '-----BEGIN RSA PRIVATE KEY-----MIICXQIBAAKBgQDE2xbyboHyOatd3sWwOxcX3iN6q7Y8EwiIeNXtYqOY0ehUGL7vK6UKEjSk+A9t1hLeqWO4hDnPdKzBhGB6PoCaULOXPQqZC5N1ieL++JtvocZeoEj7sKQYX3UCgfdLZOxU2iXJnD0Pt8wAYduddGbL/7iwgXSU+dL3OJ2t6Y3j8QIDAQABAoGBAJjAgQ/hnEf/Y/BVOwVC9Op6XwGDWMdI5agwS6AGmHeu+h63jQE91rT3543TRvWt1bqdqlm1kL5gBOWs+Mgi09qNnXo3qM/2FQtx2oLjPe0YTQlOnDw8J/LmgPuOPmUayUXjLeC4veLc1P+8bGW9rXxKKHbC0sdMqwUb8rtDRq5ZAkEA035HtGhcCeYNLbsdd5pvP2+RqpyKpriaouZbboQaY9KDwdgwKc4t2I95u4raFZ0q1sblxNoyq3im1NU7cnyuVwJBAO5IP99IvtRTbAKZzpuCSyXzR7DZzcsqNa/5B/6rdwgYoqs/UDgTYs9MpvDWoxTpiQnpOCt5gE0xf9NT3PwjAvcCQQCl/3TqbgrnnhBz92y+hpGQ2dIcdngBOd3txB65lKhd90qBKF1NQs4LLznd8LMRyeVo5H5NzvF8UtunK6JYTvJLAkAcI0X/nPyD4DICAJ2oOXOcUKUnmiC2HA7o79Rk22Sb/STAaiKT7J4fcqLID+CEKKu5EuRCJf/jnbPFhcKzt4KzAkBqAcM6gy/IlCkC1K4cQLDLCeAVupogkXd1QuxeiGAcEiXdWWXc49ou7V8uM49vgOaKDYLJGKsnrF+8u+1WMm8c-----END RSA PRIVATE KEY-----'
          decrypt.setPrivateKey(priKey)
          return decrypt.decrypt(s)
      }
  }
  },
  http: {
    post: function (model, cls, cmd, data, fu) {
      let __data = {
        model: model,
        class: cls,
        cmd: cmd,
        data: bods.json.dumps (data),
      };
      let __ps = {
        method: 'post',
        url: bods.dataurl,
        data: __data,
      };
      axios (__ps).then (function (response) {
        let __data1 = bods.json.loads (response.data['data']);
        fu (__data1);
      });
    },
    spost: function (model, cls, cmd, data, fu) {
      if (data.__environment == undefined)
        data.__environment = this.__get_environment ();
      let _jsdata = bods.json.dumps (data);
      let _secretkey = bods.storage.getitem ('secretkey');
      let _md5key = bods.exp.md5 (_jsdata + '|' + _secretkey);
      let __data = {
        model: model,
        class: cls,
        cmd: cmd,
        sessionid: bods.storage.getitem ('sessionid'),
        md5key: _md5key,
        data: _jsdata,
      };
      let __ps = {
        method: 'post',
        url: bods.dataurl,
        data: __data,
      };
      axios (__ps).then (function (response) {

        let __data1 = bods.json.loads (response.data['data']);

        if(__data1["error"]=="数据签名不正确")
        {
          window.location.href="/mine/login"
          return;
        }
        fu (__data1);
      });
    },
    __get_environment () {
      return {
        orgguid: bods.storage.getitem ('orgguid'),
        userguid: bods.storage.getitem ('userguid'),
        username: bods.storage.getitem ('username'),
      };
    },
    downfile: function (filename, isdel) {
      const url = '/data/download';
      if (isdel == undefined) isdel = 'false';
      window.location.href = url + '?filename=' + filename + '&isdel=' + isdel;
    },
    spostfile: function (url, cmd, formData, data, fu) {
      let _jsdata = bods.json.dumps (data);
      let _secretkey = bods.storage.getitem ('secretkey');
      let _md5key = bods.expmethod.md5 (_jsdata + '|' + _secretkey);
      let _data = {
        cmd: cmd,
        sessionid: bods.storage.getitem ('sessionid'),
        md5key: _md5key,
        data: _jsdata,
      };
      let ps = {
        method: 'post',
        url: bods.baseurl + url,
        data: _data,
      };
      formData.append ('data', JSON.stringify (ps));
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      axios
        .post (bods.baseurl + url, formData, config)
        .then (function (response) {
          let data = bods.json.loads (response.data['data']);
          fu (data);
        });
    },
  },
  storage: {
    getitem: function (key) {
      return window.localStorage.getItem (key);
    },
    setitem: function (key, value) {
      window.localStorage.setItem (key, value);
    },
  },
  events: {
    fns: {},
    add: function (name, fu) {
      if (bods.events.fns[name] == undefined) {
        bods.events.fns[name] = [];
      }
      bods.events.fns[name].push (fu);
      return fu;
    },
    delete: function (name) {
      delete bods.events.fns[name];
    },
    remove: function (name, fn) {
      bods.events.fns[name].pop (fn);
    },
    on: function (name, value) {
      let ls = bods.events.fns[name];
      if (ls != undefined) {
        for (let fn of ls) {
          fn (value);
        }
      }
    },
  },
  app: {
    init: function () {
      // donwn public key
      let data = {};
      bods.http.post ('cloud', 'LoginHandler', 'publicKey', data, function (
        data
      ) {
        let publicKey = data['publicKey'];
        bods.storage.setitem ('publickey', publicKey);
      });
    },
    data: function (dict) {
      let _data = {
        orgguid: bods.storage.getitem ('orgguid'),
        userguid: bods.storage.getitem ('userguid'),
        modelguid: bods.storage.getitem ('modelguid'),
      };
      for (let key in dict) {
        if (dict.hasOwnProperty (key)) {
          _data[key] = dict[key];
        }
      }
      return _data;
    },
    menu: {
      __menulist: undefined,
      data: undefined,
      __menuinit: function () {
        const that = this;
        that.__menulist = [];
        for (let node of that.data) {
          that.__menulist.push (node);
          that.__menuinitnode (node);
        }
      },
      __menuinitnode: function (node) {
        for (let c of node.nodes) {
          this.__menulist.push (c);
          this.__menuinitnode (c);
        }
      },
      getmenubyid: function (id) {
        if (this.__menulist == undefined) {
          this.__menuinit ();
        }
        for (let node of this.__menulist) {
          if (node.id == id) {
            return node;
          }
        }
        return undefined;
      },
    },
  },
};

export default bods;



// WEBPACK FOOTER //
// ./src/utils/bods.js